"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const operators_1 = require("rxjs/operators");
const app_service_1 = require("../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const forms_1 = require("@angular/forms");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const ngx_stripe_1 = require("ngx-stripe");
const countryList_1 = require("./countryList");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const BTClient = require('braintree-web/client');
const BTDropIn = require('braintree-web-drop-in');
const BTHostedFields = require('braintree-web/hosted-fields');
class BillingDialogComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(dialogRef, data, fourD, service, router, snackBar, dialog, activeRoute, translate, stripeService, uiManager, fb, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
        this.translate = translate;
        this.stripeService = stripeService;
        this.uiManager = uiManager;
        this.fb = fb;
        this.BILLING_QMAP = [
            { id: 'name' },
            { id: 'company' },
            { id: 'email' },
            { id: 'phone' }
        ];
        this.countryList = countryList_1.CountryList.countryList;
        this.elementsOptions = {
            locale: 'auto'
        };
        this.stripeInitialized = false;
        this.updating = false;
        this.plan = data.plan;
        this.refreshBilling().subscribe();
    }
    saveAndRefresh() {
        this.billingSetup.saveObservable().subscribe(_ => this.refreshBilling().subscribe());
    }
    refreshBilling() {
        return this.fourD.V.searchByObject(_4d_mapper_1.BillingSetup)
            .equals('account', this.fourD.activeTeam.id)
            .equals('active', true)
            .queryObservable().pipe(operators_1.tap(b => {
            if (b.items.length) {
                this.billingSetup = b.items[0];
                this.billingSetup.fetchObservable().subscribe(s => {
                    if (s.cards && s.cards.length) {
                        this.billingSetup['source'] = s.cards.find(c => c.default).card;
                    }
                    else {
                        this.doNewCard();
                    }
                });
            }
            else {
                this.billingSetup = new _4d_mapper_1.BillingSetup(this.fourD.V).set({ account: this.fourD.activeTeam });
                this.doNewCard();
            }
        }));
    }
    initStripe() {
        // const Stripe$: Observable<any> = this.stripeService.getStripeReference();
        // this is a reference to the stripe elements object
        // const stripe = this.stripeService.getInstance();
        this.service.V.api('/payment/info').subscribe(key => {
            var stripeKey = key.public_key;
            console.log(stripeKey);
            this.stripeService.setKey(stripeKey);
            this.stripeService.elements(this.elementsOptions)
                .subscribe(elements => {
                this.elements = elements;
                if (this.billingSetup['uid'])
                    this.stripeService.stripe;
                if (!this.card) {
                    this.card = this.elements.create('card', {
                        style: {
                            base: {
                                iconColor: '#666EE8',
                                color: '#31325F',
                                lineHeight: '40px',
                                fontWeight: 300,
                                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                fontSize: '18px',
                                '::placeholder': {
                                    color: '#CFD7E0'
                                }
                            }
                        },
                        hidePostalCode: true
                    });
                    this.card.on('blur', s => {
                        this.updating = true;
                        this.stripeService
                            .createSource(this.card)
                            .subscribe(result => {
                            if (result.source) {
                                // Use the token to create a charge or a customer
                                // https://stripe.com/docs/charges
                                this.updating = false;
                                this.billingSetup['source'] = result.source.id;
                            }
                            else if (result.error) {
                                this.updating = false;
                                // Error creating the token
                                this.openSnackBarError(result.error.message);
                            }
                        });
                    });
                }
                this.stripeInitialized = true;
            });
        });
    }
    doNewCard() {
        this.isNewCard = true;
        delete this.billingSetup['source'];
        if (!this.stripeInitialized) {
            this.initStripe();
        }
        setTimeout(() => {
            this.card.mount('#card-element1');
        }, 500);
    }
    updateDetails() {
        if (!this.billingSetup['source'] && this.plan) {
            this.openSnackBarError('PLAN.CREDIT_CARD_DETAILS');
            return;
        }
        else {
            this.updating = true;
            if (this.data.subscriptionYearly) {
                this.billingSetup['payCycle'] = 'yearly';
            }
            else {
                this.billingSetup['payCycle'] = 'monthly';
            }
            if (this.plan) {
                this.billingSetup['plan'] = this.plan.id;
                this.billingSetup.saveObservable().subscribe(s => {
                    this.success = "YA";
                    //this.fourD.account.plan = this.plan;
                    this.updating = true;
                    this.fourD.activeTeam.fetchObservable().subscribe();
                    setTimeout(() => this.dialogRef.close(true), 6000);
                }, e => {
                    this.updating = true;
                    this.error = e.message;
                });
            }
            else
                this.billingSetup.saveObservable().subscribe(s => {
                    this.success = "YA";
                    this.updating = true;
                    setTimeout(() => this.dialogRef.close(true), 6000);
                }, e => {
                    this.updating = true;
                    this.error = e.message;
                });
        }
    }
    cancel() {
        this.dialogRef.close(false);
    }
    ngAfterViewInit() {
    }
    /*
            name: @get @qMap.id + '_name'
                    number:  @get(@qMap.id + '_no1') + ' ' + @get(@qMap.id + '_no2') + ' ' + @get(@qMap.id + '_no3') + ' ' + @get(@qMap.id + '_no4')
                    exp_month: @get(@qMap.id + '_mm')
                    exp_year: @get(@qMap.id + '_yy')
                    cvc: @get(@qMap.id + '_ccv')*/
    removeCard(c) {
        this.openDialog('GENERIC.CONFIRM', 'PLAN.CONFIRM_DELETE', 'GENERIC.YES', 'GENERIC.NO').subscribe(b => {
            if (b)
                this.fourD.V.api('/api/BillingSetup/' + this.billingSetup.id + '/' + c.card, 'delete').subscribe(s => {
                    this.refreshBilling().subscribe();
                    this.openDialog('PLAN.DELETED').subscribe();
                }, e => {
                    this.openDialog(e.message).subscribe();
                });
        });
        console.log(c);
    }
}
exports.BillingDialogComponent = BillingDialogComponent;
